import * as React from 'react'
import { CLASS_PREFIX } from 'src/constants/'
import { mapDisplayModeToConst, PostDisplayMode } from 'src/interfaces/posts'
import './inclusion_reason.scss'

type IProps = {
  content?: string | null;
  displayMode: PostDisplayMode;
};

const cls = `${CLASS_PREFIX}inclusion-reason__`

export default class InclusionReason extends React.PureComponent<IProps> {
  private cls = ''

  constructor (props: IProps) {
    super(props)
    this.cls = `${cls}${mapDisplayModeToConst[props.displayMode]}`
  }

  public render () {
    const { content } = this.props

    return (
      content ? <p className={this.cls}>{content}</p> : null
    )
  }
}
